import React from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './EmptyBackground.scss';
export var EmptyBackground = function (_a) {
    var className = _a.className;
    var new_devpage_bg = useFlag('new_devpage_bg');
    return (React.createElement("div", { className: classnames(s['root'], new_devpage_bg && s['new_devpage_bg'], className) }));
};
EmptyBackground.displayName = 'EmptyBackground';
export default EmptyBackground;
//# sourceMappingURL=EmptyBackground.js.map